import React, { FC, useState, } from "react";
import { getFileExtensionInFirebaseStorageUrl } from "../../../utils/helpers/file";
import {
  Wrapper,
  Header,
  LinkFileWrapper,
  LinkFilesWrapper,
  LinkFileTitleWrapper,
  TextEllipsisWrapper,
  DropdownWrapper,
  MenuWrapper,
  MenuItemWrapper,
} from "./elements";
import { DocumentsProps } from "./types";
import { DocumentViewerPopup } from "../DocumentViewerPopup";
import { ApplicantDocument } from "../../../core/entities/applicant";
import { Dropdown, } from "antd";
import Icon from "@ant-design/icons";
import { ReactComponent as MeatballsComponent } from '../../../assets/icons/meatballs.svg';

const MeatballsIcon = (props: any) => <Icon component={MeatballsComponent} {...props} />;

const Documents: FC<DocumentsProps> = (props) => {
  const { documents, resume, onShowDeleteModal, onDownloadDocument  } = props;
  const [documentSrc, setDocumentSrc] = useState<string>("");
  const [isDocumentViewerPopupOpen, setDocumentViewerPopupOpen] = useState<boolean>(false);

  const selectDocument = (src: string) => { 
    setDocumentSrc(src);
    setDocumentViewerPopupOpen(true);
  };

  const closeDocumentViewerPopup = () => {
    setDocumentViewerPopupOpen(false);
    setDocumentSrc("");
  };

  const onShowDeleteModalHandler = (document: ApplicantDocument) => {
    onShowDeleteModal(document);
  };

  const onDownloadDocumentHandler = async (document: ApplicantDocument) => {
    onDownloadDocument(document.src, document.name);
  };

  let sortedDocuments = [...documents].sort((a,b) => b.dateUploaded.toMillis() - a.dateUploaded.toMillis());
  const resumeName = `resume.${getFileExtensionInFirebaseStorageUrl(resume)}`;

  return (
    <>
      <Wrapper>
          <Header>Documents</Header>
          <LinkFilesWrapper>
            {
              sortedDocuments.map((document, index) => (
                <LinkFileWrapper key={index} >
                  <TextEllipsisWrapper
                    content={document.name}
                    onClick={() => selectDocument(document.src)}
                    tooltip={{
                      color: "#393939",
                      placement: "bottomRight",
                      overlayStyle: {
                        maxWidth: "800px",
                      },
                      overlayInnerStyle: {
                        transform: "translate(50px, -8px)",
                        wordBreak: "break-all",
                        background: "#393939",
                        color: "#FFFFFF",
                        borderRadius: "5px",
                        fontWeight: "normal",
                        padding: "8px 14px",
                      },
                    }}
                  />
                  <DropdownWrapper>
                    <Dropdown
                      trigger={["click"]}
                      dropdownRender={() => (
                        <MenuWrapper style={{ marginTop: "-9px" }}>
                          <MenuItemWrapper key="download" onClick={() => onDownloadDocumentHandler(document)}>Download</MenuItemWrapper>
                          <MenuItemWrapper key="delete" onClick={() => onShowDeleteModalHandler(document)}>Delete</MenuItemWrapper>
                        </MenuWrapper>
                      )}
                      placement="bottomRight"
                      overlayStyle={{ minWidth: "120px", }}
                    >
                      <MeatballsIcon style={{ fontSize: "24px", color: "#000000" }} />
                    </Dropdown>
                  </DropdownWrapper>
                </LinkFileWrapper>
              ))
            }
            <LinkFileTitleWrapper key={resume} onClick={() => selectDocument(resume)}>
              { resumeName }
            </LinkFileTitleWrapper>
          </LinkFilesWrapper>
      </Wrapper>
      <DocumentViewerPopup 
        src={documentSrc} 
        closePopup={closeDocumentViewerPopup} 
        isOpen={isDocumentViewerPopupOpen} 
      />
    </>
  );
};

export default Documents;
